import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const resultImages = ['https://cdn.magicpatterns.com/uploads/ecqawfmrDuXHCtiWNPBAkF/image.png', 'https://cdn.magicpatterns.com/uploads/m2HVoLSeiYt6PrXCmpzYXG/image.png', 'https://cdn.magicpatterns.com/uploads/2JJDjsbdftYoJNMjDzNJYR/image.png', 'https://cdn.magicpatterns.com/uploads/wYBzG1C2mPTUouZYefGe2t/image.png', 'https://cdn.magicpatterns.com/uploads/idS7oMbgaN9ac2hb9aNZQA/image.png'];
const beforeImages = ['https://cdn.magicpatterns.com/uploads/befWjZNtk1Kzw6ruZphVyD/WhatsApp_Image_2026-05-02_at_22.08.03_(2).jpg', 'https://cdn.magicpatterns.com/uploads/g1egev8N4akbkZNtXocYzF/WhatsApp_Image_2026-05-02_at_22.08.03.jpg', 'https://cdn.magicpatterns.com/uploads/2K1CzXbcjYAezJTLa9sUSn/WhatsApp_Image_2026-05-02_at_22.15.42_(1).jpg'];
const lifeImages = ['https://cdn.magicpatterns.com/uploads/fQpJkUjt1R3RWzkwYt6DaD/WhatsApp_Image_2026-05-02_at_22.20.20.jpg', 'https://cdn.magicpatterns.com/uploads/nTYCMskRwtN3osvAAzwFK9/WhatsApp_Image_2026-05-02_at_22.58.39.jpg', 'https://cdn.magicpatterns.com/uploads/83qTWzNa1nqYosmjdMaVi9/WhatsApp_Image_2026-05-02_at_23.53.22_(1).jpg', 'https://cdn.magicpatterns.com/uploads/iKzX9YnRdfca4AtUQnuC7g/IMG_7620.jpg', 'https://cdn.magicpatterns.com/uploads/7pByoThoZobCp5UhEwvcCv/WhatsApp_Image_2026-05-02_at_22.17.47.jpg', 'https://cdn.magicpatterns.com/uploads/asz4YqNpKLw8V6zPXc73Lu/WhatsApp_Image_2026-05-03_at_00.02.17.jpg', 'https://cdn.magicpatterns.com/uploads/g7jZp64b5GLUsbZUNNBYAU/IMG_7698.jpg', 'https://cdn.magicpatterns.com/uploads/6CHYXvBen1tpaSGGrt4EXT/WhatsApp_Image_2026-05-02_at_22.08.03_(3).jpg', 'https://cdn.magicpatterns.com/uploads/gQPiCcLr1e4JCbD6QFhttA/WhatsApp_Image_2026-05-03_at_00.00.02.jpg', 'https://cdn.magicpatterns.com/uploads/wjdE8UQBY1NPoYxHp531V2/WhatsApp_Image_2026-05-03_at_00.05.58.jpg'];
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [beforeSlide, setBeforeSlide] = useState(0);
  const [lifeSlide, setLifeSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBeforeSlide(prev => (prev + 1) % beforeImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setLifeSlide(prev => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const goTo = (index: number) => setCurrentSlide(index);
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % resultImages.length);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = [{
    emoji: '❌',
    before: 'Ves cómo todos venden por internet, pero ',
    bold: 'no sabes cómo empezar',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Ganas menos de USD 3,000 y ',
    bold: 'no te alcanza?',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Estás atrapado en una rutina que no te satisface y ',
    bold: 'no sabes cómo salir de ahí?',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Compraste muchos cursos o mentorías y sigues ',
    bold: 'FRUSTRADO/A sin lograr vivir de internet?',
    after: '💰💻'
  }, {
    emoji: '❌',
    before: '¿Te cuesta avanzar y necesitas ',
    bold: 'acompañamiento REAL EN VIVO?',
    after: ''
  }];
  return <section className="py-6 md:py-10 px-4 pt-[0px] pb-[0px] bg-[#2F0240]" data-id="element-121" data-mp="28szpzgrimkgt">
      <div className="max-w-6xl mx-auto" data-id="element-122" data-mp="36958pqf2wsal">
        <div className="text-center mb-8" data-id="element-123" data-mp="36azqivv204ag">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-[0_0_15px_rgba(34,197,94,0.5)] animate-glow-badge pt-[6px] pb-[6px] mt-[10px] mb-[10px] bg-[#9C16A3]" data-id="element-124" data-mp="31hn6z058enok">
            <span data-id="element-125" data-mp="2q31zml9nlqec"></span>
            <span data-id="element-126" data-mp="2c1zau0r9y1zq">💰DOMINANDO SHOPIFY💰</span>
          </div>

          <h1 className="mx-auto mb-8 max-w-6xl text-[clamp(1.55rem,7.2vw,4.75rem)] font-black uppercase leading-[0.96] tracking-[-0.055em] text-white" data-id="element-127" data-mp="2c3k6xut8lszp">
            <span className="block whitespace-nowrap" data-id="element-128" data-mp="34q4vknibvqzk">
              CREA Y VENDE TU <span className="text-[#FC9DFF]" data-id="element-129" data-mp="34t0uae202jp2">EBOOK</span>
            </span>
            <span className="block whitespace-nowrap" data-id="element-130" data-mp="38rgp344bowd1">
              MIENTRAS DUERMES
            </span>
            <span className="block whitespace-nowrap" data-id="element-131" data-mp="2v0ldvl6cq36a">
              → GENERA <span className="text-[#FC9DFF]" data-id="element-132" data-mp="2zywm5rh005me">USD 100–300</span>
            </span>
            <span className="block whitespace-nowrap" data-id="element-133" data-mp="3nozapxlpetg9">
              <span className="text-[#FC9DFF]" data-id="element-134" data-mp="3nnfvmabsaog2">DIARIOS</span> EN{' '}
              <span className="text-[#FC9DFF]" data-id="element-135" data-mp="3sh0u03hahkfs">AUTOMÁTICO</span>
            </span>
          </h1>

          <div className="mb-8 flex justify-center" data-id="element-136" data-mp="5oc59t6n9yjo">
            <div className="aspect-[9/16] w-full max-w-[360px] overflow-hidden rounded-xl bg-black shadow-2xl" data-id="element-137" data-mp="1o1odlhbdnq1">
              <iframe src="https://player.vimeo.com/video/1232529699?badge=0&autopause=0&player_id=0&app_id=58479" title="Bienvenidos" className="h-full w-full border-0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen data-id="element-138" data-mp="ffzqvdgisld8" />
            </div>
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto text-[#FACC15] text-[14px] pt-[0px] pb-[0px] mt-[30px] mb-[30px]" data-id="element-139" data-mp="3ss06b14ty82q">
            ⭐ +500 alumnos ⚡ Acceso inmediato 🛡️ Garantía de 14 días 🔒 Pago
            internacional seguro
          </p>

          <div className="rounded-xl p-6 mb-8 max-w-3xl mx-auto bg-[#9C16A3] animate-neon-violet" data-id="element-140" data-mp="133zi0ehqudsc">
            <p className="md:text-xl font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[16.5px]" data-id="element-141" data-mp="1b4p10kqbszmn">
              Generamos más de USD 50,000 en los últimos 6 meses y te enseñamos
              el paso a paso ✅ Desde cero ✅ Sin experiencia ✅ Sin mostrarte en
              cámara ✅
            </p>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-142" data-mp="1p4ztttb74oag"></p>
        </div>

        <div className="text-center mt-[-10px] mb-[-10px]" data-id="element-143" data-mp="rj2hyerbnh7h">
          <CTAButton text="👉🏻QUIERO VENDER EN AUTOMÁTICO" onClick={scrollToCompra} size="large" className="w-full md:w-auto text-2xl animate-pulse-green" data-id="element-144" data-mp="wgayyc0qhf75" />
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-145" data-mp="11e43z1qaw35u">
          <h3 className="text-2xl md:text-3xl font-black text-center uppercase text-[#FFFFFF] mt-[20px] mb-[20px]" data-id="element-146" data-mp="167p3iy7jl575">
            Nuestros Resultados👇
          </h3>
          <div className="relative" data-id="element-147" data-mp="dq30i77zbcxa">
            <div className="overflow-hidden rounded-2xl border-2 border-[#FC9DFF] shadow-xl" data-id="element-148" data-mp="dpb6h0u15n94">
              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-149" data-mp="65sg29igirqi">
                {resultImages.map((img, index) => <img key={index} src={img} alt={`Resultado ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-150" data-mp="3scqo13605p6t" data-mpi={index} />)}
              </div>
            </div>

            <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-151" data-mp="3jeezr7slz3hj">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-152" data-mp="39namccikzqot" />
            </button>
            <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-153" data-mp="39lg0mvzhjujo">
              <ChevronRightIcon className="w-5 h-5" data-id="element-154" data-mp="2zo2yuwi4ufnz" />
            </button>

            <div className="flex justify-center gap-2 mt-4" data-id="element-155" data-mp="2vnj05ohwv3zq">
              {resultImages.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-156" data-mp="nejn3hivyvyi" data-mpi={index} />)}
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-8 md:p-10 mb-10 max-w-3xl mx-auto bg-[#3E0400]" data-id="element-157" data-mp="dizqsu0etv98">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-8 text-center" data-id="element-158" data-mp="ief51n2bxt66">
            ¿TE IDENTIFICAS?
          </h3>
          <div className="space-y-4" data-id="element-159" data-mp="9fbi2801ktme">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 border border-amber-600/40 rounded-xl px-5 py-4 bg-gray-900/60" data-id="element-160" data-mp="9gmnsdd1sbg5" data-mpi={index}>
                <span className="text-2xl flex-shrink-0 bg-gray-800 rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-161" data-mp="3vuwbek95lffv">
                  {point.emoji}
                </span>
                <p className="text-base md:text-lg font-medium text-[#FFFFFF]" data-id="element-162" data-mp="3hx7wdt1rp2iq">
                  {point.before}
                  <span className="font-bold text-[#FC9DFF]" data-id="element-163" data-mp="338eoavyo925q">{point.bold}</span>
                  {point.after}
                </p>
              </div>)}
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center" data-id="element-164" data-mp="2ybeimm5qi1f5">
          <p className="md:text-xl mb-3 font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[20px]" data-id="element-165" data-mp="3ca5q3pq3coub">
            Te entendemos... Nosotros también estuvimos ahí...💔
          </p>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-166" data-mp="3m5zdy599g4re">
          <div className="relative" data-id="element-167" data-mp="3h87aqf360w7w">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-168" data-mp="3h8z3zj9aihv0">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${beforeSlide * 100}%)`
            }} data-id="element-169" data-mp="3uzkp7em7v3w2">
                {beforeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida antes ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-square" data-id="element-170" data-mp="8s4d725ronxa" data-mpi={index} />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-171" data-mp="2qsd1i3zyd5gp">
              {beforeImages.map((_, index) => <button key={index} onClick={() => setBeforeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${beforeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-172" data-mp="2m1wk68t0gzp2" data-mpi={index} />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 px-2 text-[17px] font-[Montserrat,_sans-serif] font-[500]" data-id="element-173" data-mp="2d2hv9dshsx6o">
            Esta era nuestra vida antes: de casa al trabajo, del trabajo a casa.
            Sin tiempo... Sin dinero...estresados, endeudados y frustrados.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-10" data-id="element-174" data-mp="30p80eo0517vi">
          <h3 className="text-2xl md:text-4xl font-black text-[#FACC15] leading-tight" data-id="element-175" data-mp="2vshlw53zekc7">
            Y gracias a vender productos digitales...
          </h3>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-176" data-mp="1kcsvf3rir36n">
          <div className="relative" data-id="element-177" data-mp="1kay8xl0ln30g">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-178" data-mp="1kevs26n6fukc">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${lifeSlide * 100}%)`
            }} data-id="element-179" data-mp="1aa5mlqske8bd">
                {lifeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida ahora ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-180" data-mp="1k5h5mlb0a1ox" data-mpi={index} />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-181" data-mp="1sykioshqocj1">
              {lifeImages.map((_, index) => <button key={index} onClick={() => setLifeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${lifeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-182" data-mp="1xwlwoz0b5lnn" data-mpi={index} />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-183" data-mp="8j8rl7kdftlh">
            ❤️Nuestras vidas cambiaron❤️Hoy tenemos paz mental, libertad,
            tiempo, dinero y muchos viajes.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-12" data-id="element-184" data-mp="5jqe0tqgluuo">
          <h3 className="md:text-4xl mb-4 text-[20px] font-[700] font-[Montserrat,_sans-serif] text-[#FC9DFF]" data-id="element-185" data-mp="jum3sv1dtvh">
            Tú también puedes mejorar tu estilo de vida...
          </h3>
          <p className="text-xl md:text-2xl font-semibold text-white font-[Montserrat,_sans-serif]" data-id="element-186" data-mp="agh326k8s0s8">
            Por eso creamos el programa{' '}
            <span className="text-[#FC9DFF] font-black" data-id="element-187" data-mp="oef46a9jy0ps">DOMINANDO SHOPIFY</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-188" data-mp="jfkohh6vss9w">
          <img src="https://cdn.magicpatterns.com/uploads/fcRwvhZ941oy9wboiX5iMk/mockup_dominando_shopify.png" alt="Programa Dominando Shopify - Mockup" loading="lazy" className="w-full rounded-2xl shadow-2xl" data-id="element-189" data-mp="y59upqttzmh1" />
          <p className="text-center md:text-lg text-gray-200 mt-6 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-190" data-mp="177svm5e23p0n">
            📚 Donde te enseñamos paso a paso a crear, lanzar y escalar tu
            tienda online con Shopify + Meta Ads desde cero.
          </p>
        </div>
      </div>
    </section>;
}